var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01562 17.0156L12 12.9844H18V17.0156H8.01562ZM3.1875 15L11.8594 6.32812L10.6406 5.10938L2.01562 13.7812V15H3.1875ZM15.4219 2.8125C15.8281 3.21875 16.0312 3.6875 16.0312 4.21875C16.0312 4.75 15.8281 5.21875 15.4219 5.625L4.03125 17.0156H0V12.9375C7.5 5.46875 11.2969 1.6875 11.3906 1.59375C11.7969 1.1875 12.2656 0.984375 12.7969 0.984375C13.3281 0.984375 13.7969 1.1875 14.2031 1.59375L15.4219 2.8125Z",
    fill: "#B33939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenOutline);
export default __webpack_public_path__ + "static/media/pen-outline.078afeb8.svg";
export { ForwardRef as ReactComponent };